import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ text, ...args }) {
    super(args)
    const { form, fieldName, fieldValue } = this.formData
    const value = text || fieldValue
    this.children = [{ component: 'p', innerText: value }]
  }
}
